import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';

interface SettingsMappingTableCellRoomNightsSignature {
  Args: {
    value: number;
  };
}

export default class SettingsMappingTableCellRoomNights extends Component<SettingsMappingTableCellRoomNightsSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];

  get formattedRoomNights(): string {
    const formattedRoomNights = this.hotelAndMarketService.formatRate(
      this.args.value,
      false,
      true,
      { maximumFractionDigits: 0, minimumFractionDigits: 0 },
      false,
    );

    if (!formattedRoomNights) {
      return this.intl.t('general.missing');
    }

    return formattedRoomNights;
  }

  <template>{{this.formattedRoomNights}}</template>
}
